import { post } from './api';

const TRACK_PATH = '/api/analytics/track';

function getOrCreateSessionId() {
    let sessionId = localStorage.getItem('vid_session');
    if (!sessionId) {
        // Generate a UUID v4
        sessionId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
        localStorage.setItem('vid_session', sessionId);
    }
    return sessionId;
}

// Guards against a burst of duplicate visits inflating the analytics count —
// whatever causes rapid repeated calls for the *same* URL (a redirect loop, a
// double-fired effect, a user mashing back/forward), only the first one in a
// short window actually gets sent.
const DEDUPE_WINDOW_MS = 3000;
let lastTrackedUrl = null;
let lastTrackedAt = 0;

// Uses the same axios instance as all other API calls —
// base URL is resolved automatically per environment (localhost/SIT/production).
export async function trackPageView(userId) {
    const url = window.location.href;
    const now = Date.now();
    if (url === lastTrackedUrl && now - lastTrackedAt < DEDUPE_WINDOW_MS) {
        return;
    }
    lastTrackedUrl = url;
    lastTrackedAt = now;

    try {
        await post(TRACK_PATH, {
            session_id: getOrCreateSessionId(),
            user_id:    userId || null,
            page_url:   url,
            referrer:   document.referrer || '',
        });
    } catch {
        // Silently ignore — tracking must never break the app
    }
}

export default trackPageView;
